import { Alert, Button, Paper, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import type { RegistryOffer } from '../../api/registryDealTypes';
import { errorMessage } from '../../api/registryApi';
import { useRegistrySession } from '../../session/RegistrySession';
import { PageHeader, SectionCard, StatusChip } from '../../ui/primitives';

export default function LiveOffersPage() {
  const session = useRegistrySession()!;
  const navigate = useNavigate();
  const [offers, setOffers] = useState<RegistryOffer[]>([]);
  const [error, setError] = useState('');
  useEffect(() => {
    session.api
      .listOffers()
      .then(setOffers)
      .catch((failure) => setError(errorMessage(failure)));
  }, [session]);
  return (
    <>
      <PageHeader
        title="Offers"
        subtitle="Registry offers. Application totals become available in milestone 5."
        actions={
          <Button variant="contained" onClick={() => navigate('/manager/setup')}>
            Set up a deal
          </Button>
        }
      />
      <Alert severity="success" sx={{ mb: 2 }}>
        Live from Fides
      </Alert>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <SectionCard title="Offers">
        <Stack spacing={1}>
          {offers.length === 0 && <Typography>No offers yet.</Typography>}
          {offers.map((offer) => (
            <Paper key={offer.externalId} variant="outlined" sx={{ p: 2 }}>
              <Stack direction="row" alignItems="center" spacing={2}>
                <div style={{ flex: 1 }}>
                  <Typography sx={{ fontWeight: 700 }}>{offer.title}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {offer.fund.name} · {offer.unitClass.name} · closes {offer.closeDate}
                  </Typography>
                </div>
                <StatusChip status={offer.status} />
                <Button onClick={() => navigate(`/manager/offers/${offer.externalId}`)}>
                  View
                </Button>
              </Stack>
            </Paper>
          ))}
        </Stack>
      </SectionCard>
    </>
  );
}
